import CartService from "../../services/cart.service";
import pickupPointsService from "../../services/pickupPoints.service";

const cartModule = {
  namespaced: true,
  state: {
    loading: false,
    loadingText: '',
    checkout: null,
    successAddMessage: 'Товар успешно добавлен в корзину',
    panelMessages: {},
    politicUrl: 'javascript:void(0);',
    cities: {}
  },
  getters: {
    total(state) {
      let total = 0;
      if (state.checkout) {
        total = parseFloat(state.checkout.total);
      }
      return total;
    },
    itemsPrice(state) {
      if (state.checkout && state.checkout.items_price) {
        return parseFloat(state.checkout.items_price);
      }

      return 0
    },
    deliveryPrice(state) {
      if (state.checkout && state.checkout.delivery_price) {
        return parseFloat(state.checkout.delivery_price);
      }

      return 0
    },
    count(state) {
      let count = 0;
      if (state.checkout && state.checkout.items) {
        count = state.checkout.items.length;
      }
      return count;
    },
    totalCount(state) {
      let count = 0;
      if (state.checkout && state.checkout.items) {
        state.checkout.items.forEach((item) => {
          count += item.quantity;
        })
      }

      return count;
    },
  },
  actions: {
    async loadCheckout({ state, dispatch, commit }) {
      if (!state.checkout && !state.loading) {
        commit('setLoading', true);
        await dispatch('fetchCheckout')
        commit('setLoading', false);
      }
    },
    async fetchCheckout({ commit }) {
      try {
        const result = await CartService.fetchCheckout();
        commit('setCheckout', result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async loadCities({ commit }) {
      try {
        const result = await CartService.loadCities();
        commit('setCities', result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async loadPoliticUrl({commit}) {
      try {
        const result = await CartService.loadPoliticUrl();
        commit('setPoliticUrl', result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async add({ state, dispatch, commit }, { buyable, id, quantity }) {
      try {
        const result = await CartService.add(buyable, id, quantity);
        dispatch('fetchCheckout');
        if (result.data.showError) {
          dispatch('showError', result.data);
        } else {
          dispatch('notification/showSuccessNotification', state.successAddMessage, {root:true});
        }
      } catch (e) {
        dispatch('showError', { message: 'Произошла ошибка' });
      }
    },
    async remove({ state, dispatch, commit }, { key }) {
      try {
        const result = await CartService.remove(key);
        dispatch('fetchCheckout');
        if (result.data.showError) {
          dispatch('showError', result.data);
        }
      } catch (e) {
        dispatch('showError', { message: 'Произошла ошибка' });
      }
    },
    async increase({ state, dispatch, commit }, { key, amount }) {
      try {
        const result = await CartService.increase(key, amount);
        dispatch('fetchCheckout');
        if (result.data.showError) {
          dispatch('showError', result.data);
        }
      } catch (e) {
        dispatch('showError', { message: 'Произошла ошибка' });
      }
    },
    async decrease({ state, dispatch, commit }, { key, amount }) {
      try {
        const result = await CartService.decrease(key, amount);
        dispatch('fetchCheckout');
        if (result.data.showError) {
          dispatch('showError', result.data);
        }
      } catch (e) {
        dispatch('showError', { message: 'Произошла ошибка' });
      }
    },
    showError({ dispatch, commit }, { message, type, key }) {
      if (!type) {
        dispatch('notification/showErrorNotification', message, {root:true});
      } else if (type === 'panel' && key) {
        commit('addPanelMessage', { key, message });
        setTimeout(() => {
          commit('removePanelMessage', key);
        }, 4000);
      }
    }
  },
  mutations: {
    setCheckout(state, data) {
      state.checkout = data;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setLoadingText(state, value) {
      state.loadingText = value
    },
    addPanelMessage(state, { key, message }) {
      state.panelMessages[key] = message;
    },
    removePanelMessage(state, key) {
      state.panelMessages[key] = null;
    },
    setPoliticUrl(state, data) {
      state.politicUrl = data;
    },
    setCities(state, data) {
      state.cities = data;
    },
    setDeliveryPrice(state, data) {
      state.checkout.delivery_price = data;
      const total = parseInt(state.checkout.total, 10);
      state.checkout.total = total + data;
    },
  },
};

export default cartModule;